import * as React from 'react';
import { match } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { toastr } from 'react-redux-toastr';
import MatchesCard from 'src/modules/Recognition/Match/components/MatchesCard';
import ViewButtons from '../share/ViewButtons/ViewButtons';
import { MatchesService } from 'src/share/services/matches';
import { IAgency } from 'src/share/types/agency';
import { ICase } from 'src/share/types/case/case';
import { IMatchResponse } from '../../../../../share/types/match';
import './matches.css';
import NotFoundData from '../share/NotFoundData/NotFoundData';

export interface IMatchProps {
  agency: IAgency;
  caseData: ICase;
  history: any;
  loading: boolean;
  match: match<{ caseId: string }>;
  permissionCase: boolean
  isAnETLCase: boolean;
}

export interface IMatchState {
  caseMatches: IMatchResponse[]
}

export default class Matches extends React.Component<IMatchProps, any> {
  constructor(props: IMatchProps) {
    super(props);
    this.state = {
      caseMatches: [],
      loading: true
    }
  }

  public componentDidMount() {
    this.loadCaseMatches();
  }

  public async loadCaseMatches() {
    try {
      this.setState({ loading: true }) 
      const { caseId } = this.props.match.params;
      const caseMatches = await MatchesService.getAllByCase(caseId);
      this.setState({ caseMatches });
    } catch (error) {
      toastr.error('Error', 'There was a problem fetching the case matches information from the server');
    }
    this.setState({ loading: false }) 
  }

  public render() {
    const isLoading = this.props.loading || this.state.loading;
    return (
      <div className="matches-information-content">
        <div className="help-loader">
          <BeatLoader loading={isLoading} />
        </div>
        {!isLoading && this.state.caseMatches && this.state.caseMatches.length > 0 &&
          <MatchesCard {...this.state.caseMatches[0]} loading={isLoading} type={'gmcngine'} />
        }
        {!isLoading && this.state.caseMatches.length === 0 && <NotFoundData label={'No matches assigned for this case'} />}
        <ViewButtons
          history={this.props.history}
          match={this.props.match}
          caseData={this.props.caseData}
          loading={isLoading}
          permissionCase={this.props.permissionCase}
          isAnETLCase={this.props.isAnETLCase} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/Matches/Matches.tsx